import SeoHead from '@/components/base/SeoHead';
import ScrollToTop from '@/components/base/ScrollToTop';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import BrandStory from './components/BrandStory';
import Reputation from './components/Reputation';
import ContactSection from './components/ContactSection';
import FaqSection from './components/FaqSection';

export default function AboutPage() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'https://asjym.cn' },
          { '@type': 'ListItem', position: 2, name: '关于我们' },
        ],
      },
      {
        '@type': 'AboutPage',
        name: '关于长日光阴',
        description: '长日光阴——珍藏每一寸慢时光。了解品牌故事、读者口碑和联系方式。',
        url: 'https://asjym.cn/about',
      },
      {
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: '长日光阴是什么？',
            acceptedAnswer: { '@type': 'Answer', text: '长日光阴是一个以慢生活美学为核心的内容平台。我们通过深度文章、影像作品和生活美学内容，帮助都市人找回被快节奏生活吞噬的从容与诗意。' },
          },
          {
            '@type': 'Question',
            name: '长日光阴的内容多久更新一次？',
            acceptedAnswer: { '@type': 'Answer', text: '我们保持每周更新2-3篇原创文章。慢时光通讯每周发送一封精选邮件。' },
          },
          {
            '@type': 'Question',
            name: '如何订阅慢时光通讯？',
            acceptedAnswer: { '@type': 'Answer', text: '在首页底部的订阅区域输入邮箱地址即可订阅，每周会发送一封精心编辑的邮件。' },
          },
          {
            '@type': 'Question',
            name: '我可以投稿给长日光阴吗？',
            acceptedAnswer: { '@type': 'Answer', text: '非常欢迎！通过"联系我们"表单提交创作想法或作品链接，编辑团队会在7个工作日内回复。' },
          },
          {
            '@type': 'Question',
            name: '长日光阴有线下活动吗？',
            acceptedAnswer: { '@type': 'Answer', text: '有的。定期在不同城市举办"慢时光工作坊"，内容包括茶道体验、胶片摄影漫步、手作陶艺等。' },
          },
          {
            '@type': 'Question',
            name: '如何与长日光阴进行商业合作？',
            acceptedAnswer: { '@type': 'Answer', text: '欢迎理念契合的品牌合作。通过"联系我们"表单说明合作意向，会有专人对接。' },
          },
        ],
      },
    ],
  };

  return (
    <>
      <SeoHead
        title="关于我们"
        description="了解长日光阴的品牌故事——一个以慢生活美学为核心的内容平台。五十万读者的选择，用文字、影像与生活美学找回从容与诗意。"
        keywords="长日光阴,关于我们,品牌故事,慢生活,生活美学,联系我们"
        canonicalUrl="https://asjym.cn/about"
      />
      <ScrollToTop />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />

      <Navbar />

      <main className="pt-20">
        <div className="bg-background-50">
          <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '关于我们' }]} />

          <section className="w-full px-4 md:px-6 pb-6">
            <div className="max-w-6xl mx-auto">
              <h1 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900">
                关于长日光阴
              </h1>
              <p className="text-sm text-foreground-500 mt-2 leading-relaxed">
                珍藏每一寸慢时光
              </p>
            </div>
          </section>
        </div>

        <BrandStory />
        <Reputation />
        <ContactSection />
        <FaqSection />
      </main>

      <Footer />
    </>
  );
}